export const mapMessages = (error: { message: string }) => `${error.message}\n`;
